<div class="formstep_detail"><abwesenheiten-list :nutzer="model" table-id="AbwesenheitenListInPersonal" objekt-url-name="personal"></abwesenheiten-list></div>